// import { firebaseApp } from '../AppFirebase';
import firebase from 'firebase/app';
import { action, computed, observable } from 'mobx';
import { AbstractModel } from './AbstractModel';
import { MIN_VOTES_TO_SHOW_SCORE_BUTTON, VOTE_COIN_COST } from '../constants';

export interface CurrentUser {
  /** Uid from Firebase auth service (not firestore user id) */

  coins: number;

  nameFirst?: string;
  nameLast?: string;
  registeredAt: string;

  picturesCount: number;

  votesGiven: number;
  votesReceived: number; // unlocked votes count
  votesSeen: number;
  lockedVotes: number;
  onboarding_sawResultsReceivedPrompt?: boolean;
  onboarding_sawInitialVotePairs?: boolean;
}

export class CurrentUserModel extends AbstractModel {
  @observable
  isLoading = true;
  @observable
  isLoadingAuth = true;

  @observable
  user?: CurrentUser;

  @observable
  private authId?: string;

  @observable
  isAnonymous: boolean = false;

  @computed
  get coins(): number {
    return this.user ? this.user.coins : 0;
  }

  @computed
  get isAuthenticated(): boolean {
    return !!this.authId;
  }

  @computed
  get lockedVotesCount(): number {
    return this.user?.lockedVotes ? this.user.lockedVotes : 0;
  }

  @computed
  get hasCoinsToUnlockVotes(): boolean {
    return this.coins >= VOTE_COIN_COST; // Really basic logic for now
  }

  @computed
  get isScoreScreenUnlocked(): boolean {
    return this.user?.votesGiven ? this.user?.votesGiven >= MIN_VOTES_TO_SHOW_SCORE_BUTTON : false;
  }

  get currentUserRef() {
    if (!this.authId) {
      throw new Error('missing user');
    }
    return this.rootStore.firebase.getCurrentUserRef(this.authId);
  }

  @action
  setIsAnonymous = (val: boolean) => {
    this.isAnonymous = val;
  };

  @action
  setCurrentUser = (user: CurrentUser) => {
    const updatedUser = { ...user };
    // We don't want to subscribe to coins and votes updates from store as their numbers are already updated optimistically on FE
    if (this.user) {
      updatedUser.coins = this.user.coins;
      updatedUser.votesGiven = this.user.votesGiven;
    }

    this.user = updatedUser;
    this.isLoading = false;
  };

  @action
  setAuthUser = (user?: firebase.User) => {
    if (user) {
      this.authId = user.uid;
      this.isAnonymous = user.isAnonymous;
    }
    this.isLoadingAuth = false;
  };

  @action
  setAuthId = (authID: string) => {
    this.authId = authID;
  };

  @action
  setCurrentUserSawResult = () => {
    this.rootStore.firebase.setCurrentUserSawResult(this.currentUserRef);
  };

  @action
  logout = () => {
    return this.rootStore.firebase.logout();
  };

  @action
  loginAnonymously = () => {
    return this.rootStore.firebase.loginAnonymously();
  };

  @action
  loginWithFacebook = () => {
    return this.rootStore.firebase.loginWithFacebook();
  };
}
